import { FieldPath, FieldValues, get, useController } from 'react-hook-form';
import { FormCheckbox, FormCheckboxProps } from '@britishcouncil/react-admin';
import { RHFormFieldProps } from './types';

type RHFormCheckboxProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = RHFormFieldProps<FormCheckboxProps<boolean>, TFieldValues, TName>;

export const RHFormCheckbox = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  name,
  control,
  rules,
  shouldUnregister,
  defaultValue,
  ...props
}: RHFormCheckboxProps<TFieldValues, TName>) => {
  const { field, formState } = useController({
    name,
    control,
    rules,
    defaultValue,
    shouldUnregister,
  });
  return (
    <FormCheckbox
      {...props}
      name={name}
      onBlur={field.onBlur}
      onChange={field.onChange}
      value={field.value}
      touched
      error={get(formState.errors, name)?.message}
    />
  );
};
